module.exports = __webpack_public_path__ + "img/wtj.bcc771ea.png";